export default {
  "HitPaw Add Music to Audio Online": "HitPaw Muziek aan Audio Online Toevoegen",
  "Add BGM to Audio without any difficulties.": "Voeg zonder problemen achtergrondmuziek aan uw audio toe.",
  "Add New": "Nieuwe toevoegen",
  "Format": "Formaat",
  "Add tracks": "Sporen toevoegen",

};
